import {
  colors,
  legendLabelsConfig,
  numberToCurrency,
  defaultXAxisGridConfig
} from './utils'

import { Chart } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export const createFundRaisingAndDistributionChart = (graphData, scope) => {
  const chartCanvas = document.getElementById('fundraisingAndDistributionChartCanvas');

  if (!chartCanvas) return;

  const chartLoader = document.getElementById('fundraisingAndDistributionChartLoader');
  chartLoader.classList.remove('lds-dual-ring');

  const tooltipBody = (item) => {
    const { formattedValue } = item;

    return ` ${formattedValue} €`;
  };

  if (!hasNonZeroDataForThisScope(graphData, scope)) { return }

  const config = {
    type: 'bar',
    data: {
      labels: graphData.map((fund) => fund.short_name),
      datasets: [
        {
          label: 'Appelé',
          backgroundColor: colors.calls,
          data: graphData,
          parsing: {
            xAxisKey: 'short_name',
            yAxisKey: `called.${scope}`,
          },
          datalabels: {
            color: colors.white,
            formatter: function(value, _context) {
              const { called, engagement } = value;
              return (
                ((called[scope] * 100) / engagement[scope]).toFixed(2) + '%'
              );
            },
            display: function(context) {
              const { called, engagement } =
                context.dataset.data[context.dataIndex];
              return called[scope] / engagement[scope] > 0.075;
            },
          },
        },
        {
          label: 'Restant à appeler',
          backgroundColor: colors.toBeCalled,
          data: graphData,
          parsing: {
            xAxisKey: 'short_name',
            yAxisKey: `toBeCalled.${scope}`,
          },
          datalabels: {
            color: colors.white,
            formatter: function(value, _context) {
              const { toBeCalled, engagement } = value;
              return (
                ((toBeCalled[scope] * 100) / engagement[scope]).toFixed(2) + '%'
              );
            },
            display: function(context) {
              const { toBeCalled, engagement } =
                context.dataset.data[context.dataIndex];
              return toBeCalled[scope] / engagement[scope] > 0.075;
            },
          },
        },
      ],
    },
    options: {
      devicePixelRatio: 1.5,
      maxBarThickness: 100,
      scales: {
        x: {
          stacked: true,
          grid: defaultXAxisGridConfig,
        },
        y: {
          stacked: true,
          ticks: {
            display: false,
          },
          grid: {
            drawBorder: false,
            borderWidth: 0,
            color: 'rgba(51,205,153,0.15)',
          },
          max: () => {
            const engagements = graphData.map((fund) => fund.engagement[scope]);
            const maxEngagement = Math.max(...engagements);
            return Math.floor(maxEngagement * 1.2);
          },
        },
      },
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            ...legendLabelsConfig,
            filter: function(item, _chart) {
              return !item.text.includes('hidden');
            },
          },
        },
        tooltip: {
          callbacks: {
            label: tooltipBody,
          },
        },
      },
    },
  };

  return new Chart(chartCanvas, {
    plugins: [ChartDataLabels],
    ...config,
  });
}

function hasNonZeroDataForThisScope(graphData, scope) {
  return graphData.some((fund) => {
    return [fund.called[scope], fund.toBeCalled[scope]].some(value => value !== 0)
  })
}
